const api = process.env.VUE_APP_API_URL;
export const base_bome = api + "/v1/bome";
